import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'usPhoneNumber'
})
export class UsPhoneNumberPipe implements PipeTransform {

  transform(value: string|null): string {
    if (!value) return "";
    const cleaned = value.replace(/\+1|\D/g, '');

    if (cleaned.length === 0) return cleaned;
    if (cleaned.length < 3) return cleaned;

    const areaCode = cleaned.substring(0, 3);
    const middle = cleaned.substring(3, 6);
    const last = cleaned.substring(6, 10);

    if (middle.length === 0) return `(${areaCode})`;
    if (last.length === 0) return `(${areaCode}) ${middle}`;

    return `(${areaCode}) ${middle}-${last}`;
  }

}
